import { call, put, takeLatest } from "redux-saga/effects";
import { authService } from "./resource.service";
import {
   CREATE_RESOURCE,
   GET_RESOURCE,
   GET_RESOURCE_BY_ID,
   GET_RESOURCE_BY_ID_SUCCESS,
   GET_RESOURCE_SUCCESS,
   EDIT_RESOURCE,
   DELETE_RESOURCE,
   UPLOAD_RESOURCE_DOCUMENT,
   EDIT_RESOURCE_DOCUMENT,
   GET_RESOURCE_DOCUMENT,
   DELETE_RESOURCE_DOCUMENT,
   GET_RESOURCE_DOCUMENT_SUCCESS, EDIT_RESOURCE_ACCESS, GET_RESOURCE_ACCESS, GET_RESOURCE_ACCESS_SUCCESS,
} from './resource.types';
import { httpRequestsOnErrorsActions } from "../http_requests_on_errors";
import { httpRequestsOnLoadActions } from "../http_requests_on_load";
import { httpRequestsOnSuccessActions } from "../http_requests_on_success";

/** Resource */

function* createResource(action) {
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
   try {
      yield call(authService.createResourceService, action.payload.body);
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
   }
}

function* editResource(action) {
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
   try {
      yield call(authService.editResourceService, action.payload.id, action.payload.body);
      const res = yield call(authService.getResourceByIdService, action?.payload?.id);
      yield put({
         type: GET_RESOURCE_BY_ID_SUCCESS,
         payload: res.data,
      });
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));

      // yield put({
      //    type: GET_RESOURCE_BY_ID,
      //    payload: action.payload.id,
      // });
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
   }
}

function* getResource(action) {
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   if (action.payload.load !== "noLoad") {
      yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   }
   try {
      const res = yield call(authService.getResourceService, action?.payload?.data);
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put({
         type: GET_RESOURCE_SUCCESS,
         payload: res.data,
      });
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      if (err?.data?.message === "Internal server error") {
         yield put(
            httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message)
         );
      }
   }
}

function* getResourceById(action) {
   yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   try {
      const res = yield call(authService.getResourceByIdService, action.payload);
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put({
         type: GET_RESOURCE_BY_ID_SUCCESS,
         payload: res.data,
      });
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      if (err?.data?.message === "Internal server error") {
         yield put(
            httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message)
         );
      }
   }
}

function* deleteResource(action) {
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
   try {
      yield call(authService.deleteResourceService, action.payload);
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
   }
}

/** End */

/** Resource Documents */
function* uploadResourceDocument(action) {
   yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
   try {
      yield call(authService.uploadService, action.payload.file, action.payload.id);
      yield put({
         type: GET_RESOURCE_DOCUMENT,
         payload: { id: action?.payload?.id, load: 'noLoad' },
      });
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
   }
}

function* editResourceDocument(action) {
   yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
   try {
      yield call(authService.editService, action?.payload);
      yield put({
         type: GET_RESOURCE_DOCUMENT,
         payload: { id: action?.payload?.id, load: 'noLoad' },
      });
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
   }
}

function* getResourceDocument(action) {
   if (action?.payload?.load !== 'noLoad') {
      yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   }
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
   try {
      const res = yield call(authService.getFilesService, action.payload.id);
      yield put({
         type: GET_RESOURCE_DOCUMENT_SUCCESS,
         payload: res?.data,
      });
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
   }
}

function* deleteResourceDocument(action) {
   yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
   try {
      yield call(authService.deleteFilesService, action.payload.resourceId, action.payload.id);
      const res = yield call(authService.getFilesService, action.payload.resourceId);
      yield put({
         type: GET_RESOURCE_DOCUMENT_SUCCESS,
         payload: res?.data,
      });
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
      yield put(httpRequestsOnSuccessActions.removeSuccess('MINI_LOAD'));
   } catch (err) {
      yield put(httpRequestsOnSuccessActions.removeSuccess('MINI_LOAD'));
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
   }
}

/** End */

/** Resource Access */

function* editResourceAccess(action) {
   yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
   try {
      yield call(authService.editResourceAccessService, action?.payload?.id, action?.payload?.body);
      const res = yield call(authService.getResourceAccessService, action.payload.id);
      yield put({
         type: GET_RESOURCE_ACCESS_SUCCESS,
         payload: res?.data,
      });
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
   }
}

function* getResourceAccess(action) {
   if (action?.payload?.load !== 'noLoad') {
      yield put(httpRequestsOnLoadActions.appendLoading(action.type));
   }
   yield put(httpRequestsOnErrorsActions.removeError(action.type));
   yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
   try {
      const res = yield call(authService.getResourceAccessService, action.payload.id);
      yield put({
         type: GET_RESOURCE_ACCESS_SUCCESS,
         payload: res?.data,
      });
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
   } catch (err) {
      yield put(httpRequestsOnLoadActions.removeLoading(action.type));
      yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
   }
}


/** End */
export const watchResource = function* watchResourceSaga() {
   /** Resource */
   yield takeLatest(CREATE_RESOURCE, createResource);
   yield takeLatest(EDIT_RESOURCE, editResource);
   yield takeLatest(GET_RESOURCE, getResource);
   yield takeLatest(GET_RESOURCE_BY_ID, getResourceById);
   yield takeLatest(DELETE_RESOURCE, deleteResource);
   /** End */
   
   /** Resource Documents */
   yield takeLatest(UPLOAD_RESOURCE_DOCUMENT, uploadResourceDocument);
   yield takeLatest(EDIT_RESOURCE_DOCUMENT, editResourceDocument);
   yield takeLatest(GET_RESOURCE_DOCUMENT, getResourceDocument);
   yield takeLatest(DELETE_RESOURCE_DOCUMENT, deleteResourceDocument);
   /** End */

   /** Resource Access */
   yield takeLatest(EDIT_RESOURCE_ACCESS, editResourceAccess);
   yield takeLatest(GET_RESOURCE_ACCESS, getResourceAccess);
   /** End */
};
